export const SET_ALL_SHIPMENTS =
  "Setze alle Lieferungen der Auftragsunterlagen (und Nachschreiben)";
export const SET_CURRENT_SHIPMENT =
  "Setze aktuelle Lieferung der Auftragsunterlagen (und Nachschreiben)";
export const SET_LOCK = "Setze das Shipment Lock";
